import React from "react";
import {useSelector} from "react-redux";

import {Anchor} from "../../common/Anchor";
import {SectionTitle} from "../../common/sectionTitle/SectionTitle";
import {productSelectors} from "../_core/productSelectors";
import {PRODUCT_TYPES} from "../../../api/products/productBaseConstants";
import {sortByPosition} from "../../../utils/utils";
import {RollListItem} from "../rolls/RollListItem";
import {RollsetListItem} from "../rollsets/RollsetListItem";
import {PokeListItem} from "../poke/PokeListItem";
import {BentoListItem} from "../bento/BentoListItem";
import {SoupListItem} from "../soups/SoupListItem";
import {DessertListItem} from "../desserts/DessertListItem";
import {DrinkListItem} from "../drinks/DrinkListItem";
import {WarmerListItem} from "../warmers/WarmerListItem";
import {SauceListItem} from "../garnishes/sauce/SauceListItem";
import {GarnishListItem} from "../garnishes/garnish/GarnishListItem";


const renderProduct = (product) => {
  switch (product.type) {
    case PRODUCT_TYPES.roll.id:
      return <RollListItem roll={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.rollset.id:
      return <RollsetListItem rollset={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.poke.id:
      return <PokeListItem poke={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.bento.id:
      return <BentoListItem bento={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.soup.id:
      return <SoupListItem soup={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.dessert.id:
      return <DessertListItem dessert={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.drink.id:
      return <DrinkListItem drink={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.warmer.id:
      return <WarmerListItem warmer={product} key={`${product.type}-${product.id}`}/>;
    case PRODUCT_TYPES.garnish.id:
      if (product.subtype === PRODUCT_TYPES.garnish.subtypes.sauce.id) {
        return <SauceListItem sauce={product} key={`${product.type}-${product.id}`}/>;
      }
      return <GarnishListItem garnish={product} key={`${product.type}-${product.id}`}/>;
    default:
      return null;
  }
};

export const MenuProductsSection = ({id, title}) => {
  const products = useSelector(productSelectors.all)
    .filter(product => product.menuSection === id)
    .sort(sortByPosition);

  if (!products.length) {
    return null;
  }

  return (
    <div className="main-goods">
      <Anchor id={id} top={-120}/>
      <SectionTitle title={title}/>
      <ul className="main-goods__list">
        {products.map(renderProduct)}
      </ul>
    </div>
  );
};
